import { sendWebsocketMessage } from '../../../../../../App';

export function closePartialPosition(
  tradePlanId,
  quantity,
  symbol,
  limitPrice,
  cancelOpenOrders
) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'userPartialClose',
    value: {
      qty: quantity,
      symbol,
      limitPrice,
      cancelOpenOrders,
    },
  };
  sendWebsocketMessage(msg);
}
